import { css, keyframes } from '@emotion/core'
import styled from '@emotion/styled'
import { white, MQ, mobileMax } from '@css/constants'

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

export const Overlay = styled('div')<{ leaving: boolean }>(props => css`
  animation: ${fadeIn} 300ms ease;
  background-color: rgba(0, 0, 0, ${props.leaving ? 0 : 0.6});
  transition: background-color 1s ease;
  outline: none;
  overflow: auto;
  position: fixed;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  outline: none;
  z-index: 99999;
`)

export const PopupModal = styled('div')<{
  maxWidth: number
  pushDown?: boolean
}>((props) => css`
  position: relative;
  width: 80%;
  max-width: ${props.maxWidth}px;
  margin: ${props.pushDown ? '0 auto' : '20px auto 40px'};
  background-color: ${white};
  border-radius: 5px;

  ${MQ.SMALL_SCREENS} {
    width: 95%;
  }
`)

export const PopupContentWrapper = styled('div')(css`
  width: 90%;
  margin: 0 auto;
  padding: 40px 0 30px;

  ${MQ.MOBILE} {
    width: 95%;
    padding: 30px 0 10px;
  }

  @media(max-width: ${mobileMax}) {
    padding-top: 65px;
  }
`)

const BaseButton = styled('button')(css`
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  background: transparent;
  border-width: 0.0625rem;
  border-style: solid;
  border-color: transparent;
  border-image: initial;
  border-radius: 3rem;
  margin: 0px;
  overflow: visible;
  padding: 0.625rem;
  text-decoration: none;
  transition: all 0.2s ease 0s;
`)

export const ExitButton = styled(BaseButton)(css`
  position: absolute;
  right: 15px;
  top: 15px;
`)
